module.exports = __webpack_public_path__ + "img/philosophy.4f2a9a1.jpg";